import {
    AgentUsageColumn,
    AgentUsageView,
} from "@common/types/views/agentUsageView";
import { ViewDensity, ViewType } from "@common/types/views/views";

export function createDefaultAgentUsageView(): AgentUsageView {
    return {
        type: ViewType.AGENT_USAGE,
        columns: [
            { id: AgentUsageColumn.CLIENT },
            { id: AgentUsageColumn.LAST_ACTIVITY },
            { id: AgentUsageColumn.FREE_TOKENS },
            { id: AgentUsageColumn.PAID_TOKENS },
            { id: AgentUsageColumn.SHARE_OF_USAGE },
            { id: AgentUsageColumn.TASKS },
        ],
        filters: {},
        options: {
            density: ViewDensity.MD,
        },
    };
}
